import Row from '../../../Common/Row';
import Inputs from '../../../Inputs';
import Typography from '../../../../kingpin/atoms/Typography';
import React, { useCallback, useContext, useMemo } from 'react';
import { BonusRecordTaggingContext } from './BonusRecordTaggingProvider';
import Button from '../../../../kingpin/atoms/Button';
import usePopup from '../../../../hooks/usePopup';
import UpdatePopup from './UpdatePopup';
import PeriodRefiner from './PeriodRefiner';
import DeletePopup from './DeletePopup';
import {
  DEFAULT_PRIMARY_ACTION_BUTTON_TEXT,
  DEFAULT_SECONDARY_ACTION_BUTTON_TEXT,
  PERIOD_LOCKED_MESSAGE,
} from './tagConstants';
import PermissionGates from '../../../PermissionGates';
import PERMISSIONS from '../../../../permissionDefinitions';

const GridInputs = () => {
  const {
    isShowingAllFields,
    setIsShowingAllFields,
    selectedDocumentIds,
    taggedDocumentIds,
    setDateScopeOverride,
    dateRangeWindow,
    gridConfig,
    isReadOnly,
  } = useContext(BonusRecordTaggingContext);
  const {
    open: openUpdate,
    isOpen: isUpdateOpen,
    close: closeUpdate,
  } = usePopup();
  const {
    open: openDelete,
    isOpen: isDeleteOpen,
    close: closeDelete,
  } = usePopup();

  const onChange = useCallback(
    (newDate: DateRangeInput) => {
      setDateScopeOverride(newDate);
    },
    [setDateScopeOverride],
  );

  const isDisabled = useMemo(() => {
    return (
      taggedDocumentIds.sort().join(',') ===
      selectedDocumentIds.sort().join(',')
    );
  }, [taggedDocumentIds, selectedDocumentIds]);

  if (!dateRangeWindow) return null;

  return (
    <Row spaceBetween>
      <span style={{ display: 'flex', paddingTop: 4 }}>
        <PeriodRefiner
          dateRangeWindow={dateRangeWindow}
          dateRangeChanged={onChange}
        />
        <Row style={{ gap: 5, marginLeft: 20, marginTop: 10 }}>
          <Inputs.Checkbox
            isChecked={isShowingAllFields}
            onToggled={() => setIsShowingAllFields(!isShowingAllFields)}
          />
          <Typography.Body type="Label">Show All Fields</Typography.Body>
        </Row>
      </span>
      <PermissionGates.Has
        requiredPermission={PERMISSIONS.DRIVER_BONUS.EXCLUSIONS_WRITE}
      >
        <Row style={{ gap: 12 }} spaceBetween>
          <Button
            size={'Medium'}
            type={'Secondary'}
            onClick={openDelete}
            isDisabled={isReadOnly || taggedDocumentIds.length === 0}
            isDisabledMessage={isReadOnly ? PERIOD_LOCKED_MESSAGE : undefined}
            testId={'delete-exclusions'}
            label={
              gridConfig?.secondaryActionButtonText ||
              DEFAULT_SECONDARY_ACTION_BUTTON_TEXT
            }
          />
          <Button
            size={'Medium'}
            type={'Primary'}
            isDisabled={isReadOnly || isDisabled}
            isDisabledMessage={isReadOnly ? PERIOD_LOCKED_MESSAGE : undefined}
            testId={'update-exclusions'}
            onClick={openUpdate}
            label={
              gridConfig?.primaryActionButtonText ||
              DEFAULT_PRIMARY_ACTION_BUTTON_TEXT
            }
          />
        </Row>
      </PermissionGates.Has>
      <UpdatePopup isOpen={isUpdateOpen} close={closeUpdate} />
      <DeletePopup isOpen={isDeleteOpen} close={closeDelete} />
    </Row>
  );
};

export default GridInputs;
